module.exports = __webpack_public_path__ + "img/vtify.1a7336d8.png";